import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnalyticsData } from '@domgen/dgx-fe-business-models';

@Component({
  selector: 'dgx-uib-sky-covers-exclusions',
  templateUrl: './sky-covers-exclusions.component.html',
  styleUrls: ['./sky-covers-exclusions.component.scss'],
})
export class SkyCoverExclusionsComponent {
  @Input() includedTitle = 'What is covered';
  @Input() included: { text: string; icon?: string }[] = [];

  @Input() excludedTitle = 'What is not covered';
  @Input() excluded: { text: string; icon?: string }[] = [];

  @Input() deviceExcluded?: string;

  @Output() analytics: EventEmitter<AnalyticsData> = new EventEmitter();
}
